import Vue from 'vue';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import apolloClient from '@/services/apollo';
import VueApollo from 'vue-apollo';
import VueToast from 'vue-toast-notification';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import App from './App.vue';
import router from './router';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-toast-notification/dist/theme-sugar.css';

import 'cs-components';
import 'cs-components/dist/csuite.css';
import '@/assets/css/design-token.css';
import '@/assets/css/style.css';
import '@/assets/css/dialog.css';
import '@/assets/icons/css/styles.css';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueApollo);
Vue.use(VueToast);
Vue.use(VueMoment, { moment });

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.directive('router-link', {
  inserted(el, binding, vnode) {
    el.addEventListener('click', () => {
      vnode.context.$router.push(binding.value);
    });
  },
});

new Vue({
  apolloProvider,
  router,
  render: (h) => h(App),
}).$mount('#app');

moment.tz.setDefault(moment.tz.guess());
moment.locale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: '%ds',
    ss: '%ss',
    m: 'a minute',
    mm: '%dm',
    h: 'an hour',
    hh: '%dh',
    d: 'a day',
    dd: '%dd',
    M: 'a month',
    MM: '%dM',
    y: 'a year',
    yy: '%dY',
  },
});
